import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=660379d8&scoped=true&"
import script from "./Presentation.vue?vue&type=script&lang=js&"
export * from "./Presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660379d8",
  null
  
)

export default component.exports